import { PaddingProps, styledPadding } from '@tink/core/src/components/atoms/Box/Box';
import { styled } from '../../../core/theme/styled';

type FooterProps = PaddingProps & {
  stickToBottom?: boolean;
  alignItems?: 'start' | 'center';
};

export const Footer = styled.footer<FooterProps>`
  flex-direction: column;
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  padding: ${(props) => props.theme.sizes.normedium} ${(props) => props.theme.sizes.normal};
  padding-bottom: ${(props) => props.theme.sizes.normal};
  width: 100%;
  align-items: ${(props) => props.alignItems || 'center'};
  ${styledPadding};

  & footer {
    padding: 0;
  }

  ${({ stickToBottom }) => stickToBottom && 'margin-top: auto'}
`;

export const FooterText = styled.div`
  color: ${(props) => props.theme.configuration.secondaryTextColor};
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  line-height: ${(props) => props.theme.typography.caption.lineHeight};
`;

export const FooterLegalDisclaimer = styled(Footer)`
  padding-top: 0;
`;
